import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../CSS/oppor.css";
import { FaArrowUp } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useLanguageData } from '../../hooks/useLanguageData';

function Action() {
  const { t, i18n } = useTranslation();
  const [sectors, setSectors] = useState([]);
  const navigate = useNavigate();

  // Hook pour les partenaires
  const { 
    data: partnersResponse, 
    loading, 
    error 
  } = useLanguageData('/api/v1/embassy/partners');

  // Traiter les données des partenaires
  useEffect(() => {
    if (partnersResponse?.data && Array.isArray(partnersResponse.data)) {
      console.log("🔍 Données API partenaires:", partnersResponse);
      
      // Définir la catégorie à filtrer selon la langue
      const targetCategory = i18n.language === 'en' 
        ? "Government action programme"  // ✅ Version anglaise
        : "Programme d'action du gouvernement"; // ✅ Version française
      
      console.log(`🎯 Filtrage avec catégorie: "${targetCategory}" (langue: ${i18n.language})`);
      
      // Filtrer avec la bonne catégorie selon la langue
      const filteredSectors = partnersResponse.data.filter(sector => 
        sector.categoryPartner === targetCategory
      );
      
      console.log(`✅ ${filteredSectors.length} partenaires trouvés pour "${targetCategory}"`);
      setSectors(filteredSectors);
    }
  }, [partnersResponse, i18n.language]); // AJOUTER i18n.language comme dépendance

  // Composant de spinner de chargement
  const LoadingSpinner = () => (
    <div className="lien-utile-container">
      <div className="lien-utile-wrapper">
        <h2 className="lien-utile-title"></h2>
        <div style={{ 
          textAlign: 'center', 
          padding: '40px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: "40px",
            height: "40px",
            border: "3px solid #f3f3f3",
            borderTop: "3px solid #1a3c5e",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: "1rem"
          }}></div>
          <p>{t('common.loading')}</p>
          
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      </div>
    </div>
  );

  const handleRedirection = (website) => {
    navigate(website);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    console.error("Erreur de chargement des partenaires :", error);
    return (
      <div className="lien-utile-container">
        <div className="lien-utile-wrapper">
          <p style={{ textAlign: 'center', padding: '2rem', color: '#dc3545' }}>
            {t('common.error')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="lien-utile-container">
      <div className="lien-utile-wrapper">
        <h2 className="lien-utile-title"></h2>
        <div className="lien-utile-grid">
          {sectors.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '2rem', gridColumn: '1/-1' }}>
              {t('action.noPartners')}
            </p>
          ) : (
            sectors.map((sector, index) => (
              <a
                key={index}
                className="lien-utile-card"
                id="lienbas"
                style={{ cursor: 'pointer' }}
                href={sector.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="lien-utile-card-content">
                  {sector.logo ? (
                    <img src={sector.logo} alt={sector.name} className="lien-utile-icon1" />
                  ) : (
                    <div className="lien-utile-icon1 placeholder"></div>
                  )}
                  <div className="lien-group">
                    <p className="lien-utile-text">{sector.name}</p>
                    {sector.details ? (
                      <p className="lien-utile-subtext">
                        {sector.details}
                      </p>
                    ) : (
                      <p className="lien-utile-subtext">-</p>
                    )}
                  </div>
                  <FaArrowUp className="lien-utile-arrow" />
                </div>
              </a>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Action;